import React, { useState } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert,
  CircularProgress,
} from '@mui/material';
import UserAutocomplete from '../../../Hooks/useUserAutocomplete';

const TransferRequestDialog = ({
  open,
  onClose,
  device,
  onSubmit,
  isLoading = false,
}) => {
  const [transferToUser, setTransferToUser] = useState(null);
  const [notes, setNotes] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    setError('');
    
    if (!transferToUser) {
      setError('Please select a user to transfer the device to');
      return;
    }

    if (transferToUser.id === device?.user?.id) {
      setError('Cannot transfer device to the current owner');
      return;
    }

    const requestData = {
      transfer_to_user_id: transferToUser.id,
      notes: notes.trim() || undefined,
    };

    onSubmit(requestData);
    
    setTransferToUser(null);
    setNotes('');
    setError('');
  };

  const handleClose = () => {
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Request Device Transfer</DialogTitle>
      <DialogContent>
        {device && (
          <Box sx={{ mb: 2 }}>
            <Alert severity="info">
              Device: {device.mac_addr}
              {device.user && ` (Current Owner: ${device.user.display_name || device.user.email})`}
            </Alert>
          </Box>
        )}
        
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box sx={{ mb: 2, mt: 1 }}>
          <UserAutocomplete
            value={transferToUser}
            onChange={setTransferToUser}
            disabled={isLoading}
            label="Transfer To User"
            placeholder="Search user..."
          />
        </Box>

        <TextField
          label="Notes (Optional)"
          fullWidth
          multiline
          rows={4}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Add any additional notes or comments..."
          disabled={isLoading}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={isLoading || !transferToUser}
          startIcon={isLoading ? <CircularProgress size={16} /> : null}
        >
          Submit Transfer Request
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferRequestDialog;



